module.exports = __webpack_public_path__ + "img/open-book.91e3dbd4.svg";